import { render, staticRenderFns } from "./PotentiallyInterestedCompanies.vue?vue&type=template&id=a7b46cb0&scoped=true&"
import script from "./PotentiallyInterestedCompanies.vue?vue&type=script&lang=js&"
export * from "./PotentiallyInterestedCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b46cb0",
  null
  
)

export default component.exports